import { OptionType } from "@silevis/reactgrid";

export * from "./app.type";
export * from "./company.type";
export * from "./person.type";
export * from "./worker.type";
export * from "./user.type";
export * from "./work.type";
export * from "./transfer.type";
export * from "./provision.type";
export * from "./tree.type";
export * from "./expense.type";
export * from "./deduction.type";
export * from "./arrangement.type";
export * from "./prefecture.type";
export * from "./client.type";
export * from "./project.type";
export * from "./task.type";
export * from "./event.type";
export * from "./orgs.type";
export * from "./position.type";
export * from "./permissions.type";
export * from "./orgNode.type";
export * from "./appraisal.type";
export * from "./lesson.type";
export * from "./salarySheet.type";
export * from "./configTax.type";
export * from "./appPermission.type";
export * from "./companyV2.type";
export * from "./tableWithForm.type";
export * from "./categoryStatus.type";
export * from "./configWorkers.type";
export * from "./displaySize.type";
export * from "./trackingTime.type";
export * from "./appV2.type";
export * from "./listMess.type";

export type Date = {
  created_at?: string;
  updated_at?: string;
};

export type IOptions = {
  value: string | number;
  label: string;
}[];

export interface ColumnDefine {
  columnId: string;
  label: string;
  width: number;
  type: "text" | "dropdown" | "number" | "date" | "checkbox";
  values?: OptionType[];
  editTable?: boolean;
}

export interface FilterParams {
  search?: string;
  sort?: "asc" | "desc";
  filter?: string[];
  filter_special_empty?: boolean;
  filterOptions?: string[];
}

export enum MODE {
  VIEW = "view",
  EDIT = "edit",
  EDIT_LAYOUT = "edit_layout",
  OVERVIEW = "overview",
  DETAIL = "detail",
}
